/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Nav_OnlineInputs */

const en_wc_nav_online = /** @type {(inputs: Wc_Nav_OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use online`)
};

/**
* | output |
* | --- |
* | "Use online" |
*
* @param {Wc_Nav_OnlineInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_nav_online = /** @type {((inputs?: Wc_Nav_OnlineInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Nav_OnlineInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_nav_online(inputs)
});
export { wc_nav_online as "wc.nav.online" }